import { createSlider } from './common';

export function createImageSlider() {
  const wrapper = '.image-slider-block .image-slider';
  const prevArrow = '.image-slider-block .nav-slider .nav-icon.prev';
  const nextArrow = '.image-slider-block .nav-slider .nav-icon.next';
  const options = {
    slidesToShow: 1,
    infinite: true,
    dots: true,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
    customPaging: () => $('<button type="button"><span class="dot black" /></button>'),
  };

  createSlider({ wrapper, prevArrow, nextArrow, options });

  // Click event to open modal
  document.querySelectorAll('.image-slider .image').forEach((img) => {
    img.addEventListener('click', function () {
      const dataIndex = this.getAttribute('data-index');
      console.log(dataIndex); // This should log the data-index value

      $('#imageModal').modal('show');

      // Destroy existing slider if it exists
      if ($('.modal-image-slider').hasClass('slick-initialized')) {
        $('.modal-image-slider').slick('unslick');
      }

      // Initialize the slider inside the modal
      const modalOptions = {
        ...options,
        initialSlide: parseInt(dataIndex, 10), // Use the data-index value
        slidesToShow: 1,
        variableWidth: false,
      };

      createSlider({
        wrapper: '.modal-image-slider',
        prevArrow: '.modal .nav-icon.prev',
        nextArrow: '.modal .nav-icon.next',
        options: modalOptions,
      });
    });
  });
  $(document).ready(function() {
    function adjustPadding() {
      $('.image-item').each(function() {
        var $image = $(this).find('.image');
        var $caption = $(this).find('.caption');
        if ($caption.length) {
          var captionHeight = $caption.outerHeight() + 24; 
          $image.css('margin-bottom', captionHeight + 'px'); 
        }
      });
    }
  
    // Adjust padding on initial load and ensure images are fully loaded
    $(window).on('load', function() {
      adjustPadding();
    });
  
    // Adjust padding on window resize
    $(window).resize(function() {
      adjustPadding();
    });
  });

}



// WEBPACK FOOTER //
// ./scripts/func/imageSlider.js